import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
  Box,
} from '@mui/material';
import React from 'react';
import {useGetCountriesQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import CountryDeleteIconButton from './CountryDeleteIconButton';
import CreateCountryModal from './CountryCreateModal';
import CountryEditIconButton from './CountryEditIconButton';
import {getImageURL} from '../../../utils/imageUrl';

const totalColumns = 4;

function CountriesTable() {
  const {data, isLoading, isError, isSuccess} = useGetCountriesQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateCountryModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="Countries Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Countries</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Flag</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">
                    <Box
                      component="img"
                      sx={{width: 40, height: 40, objectFit: 'contain'}}
                      src={getImageURL(row.flag)}
                      alt={row.name}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <CountryEditIconButton country={row} />
                    <CountryDeleteIconButton countryId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No country found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch countries.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default CountriesTable;
